<template>
    <div class="boxFull" v-show="loader">
        <div class="loader"></div>
    </div>
</template>

<script>
export default {
    name: "LoaderComponent",

    computed: {
        loader() {
            return this.$store.state.loader.loading
        }
    }
}
</script>

<style scoped>
.boxFull {
    z-index: 105;
    width: 100vw;
    height: 100vh;
    position: fixed;
    background-color: rgba(255, 255, 255, 0.6);
}

.loader {
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 5rem;
    height: 5rem;
    z-index: 101;
    margin: auto;
    border-radius: 50%;
    position: absolute;
    box-sizing: border-box;
    background: transparent;
    border: 10px solid #F25C05;
    border-top-color: #000000;
    animation: loading 1s linear infinite;
}

@keyframes loading {
    0% {
        transform: rotate(0deg);
    }

    0% {
        transform: rotate(360deg);
    }
}
</style>